import type { AnyRouter } from "@tanstack/react-router";

// Fora do adaptador (router.ts) para quem só precisa do endereço não depender da API de
// navegação, que os testes costumam substituir por um mock.
let boundRouter: AnyRouter | null = null;

export function bindRouter(router: AnyRouter): void {
  boundRouter = router;
}

export function getBoundRouter(): AnyRouter | null {
  return boundRouter;
}

/**
 * Endereço que o navegador vê para um caminho interno: o router acrescenta a base da
 * organização (`/<slug>`). Serve à navegação nativa (recarregar a página, `href` de `<a>`).
 */
export function toPublicHref(path: string, router: AnyRouter | null = boundRouter): string {
  // Relativos (`?tab=x`) e protocol-relative (`//host`) não são caminhos da aplicação.
  if (!router || !path.startsWith("/") || path.startsWith("//")) return path;
  const { pathname, search, hash } = new URL(path, "http://internal");
  return router.buildLocation({
    to: pathname,
    search: router.options.parseSearch(search),
    hash: hash.slice(1) || undefined,
  }).publicHref;
}
